<div class="page">
  <div class="state" *ngIf="loading()">{{ 'common.actions.loading' | translate }}</div>
  <div class="state error" *ngIf="!loading() && error()">{{ error() }}</div>

  <!-- DEPRECATED (2026-09-08) : alerte qualité retirée -- voir la note en tête de
       satisfaction.component.ts.
  <app-quality-alert
    [show]="showQualityAlert()"
    [message]="alertMessage()"
    [criticalCount]="criticalCount()">
  </app-quality-alert>
  -->

  <div class="card" *ngIf="!loading() && !error() && data() as response">
    <div class="card-header">
      <div class="header-top">
        <div>
          <h1>{{ 'satisfaction.main.title' | translate }}</h1>
          <p class="subtitle">{{ 'satisfaction.main.subtitle' | translate }}</p>
        </div>
        <div class="header-actions">
          <!-- DEPRECATED (2026-09-08) : décision produit de retirer les actions correctives de
               Satisfaction -- bouton "Voir les actions" (déjà invisible, style="display:none"
               préexistant) et filtre "Actions en cours" retirés. Voir la note complète en tête de
               satisfaction.component.ts. Le chip "recontact" (à relancer) N'EST PAS concerné,
               aucun rapport avec les actions correctives. -->
          <div class="action-buttons">
            <button
              class="filter-chip"
              [class.active]="activeFilter() === 'recontact'"
              (click)="setFilter('recontact')">
              <svg viewBox="0 0 24 24" width="16" height="16">
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="currentColor"/>
              </svg>
              {{ 'satisfaction.main.recontactChip' | translate }}
              <span class="filter-count" *ngIf="recontactCount() > 0">{{ recontactCount() }}</span>
            </button>
            <button class="btn btn-secondary" (click)="exportArchivedFeedbacks()">
              {{ 'satisfaction.common.archivesLabel' | translate }} ({{response.counts.archived_feedbacks}})
            </button>
          </div>
          <button
            *ngIf="!useCardsView()"
            class="btn-filter"
            [class.active]="showPendingOnly()"
            (click)="togglePendingFilter()">
            <svg viewBox="0 0 24 24" width="16" height="16">
              <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="currentColor"/>
            </svg>
            {{ 'satisfaction.main.pendingReplyFilter' | translate }}
            <span class="filter-count" *ngIf="pendingCount() > 0">({{ pendingCount() }})</span>
          </button>
          <div class="stat">
            <span class="stat-value">{{ response.feedbacks.length }}</span>
            <span class="stat-label">{{ 'satisfaction.main.totalReviewsLabel' | translate }}</span>
          </div>
        </div>
      </div>
    </div>



    <!-- Tableau ou Cards -->
    <app-feedbacks-table
      *ngIf="!useCardsView()"
      [feedbacks]="filteredFeedbacks()"
      [showPendingOnly]="showPendingOnly()"
      [sortField]="sortField()"
      [sortDirection]="sortDirection()"
      (sort)="sortBy($event)"
      (openReplyModal)="openReplyModal($event)"
      (openCallModal)="openCallModal($event)"
      (archiveFeedback)="handleArchiveFeedback($event)">
    </app-feedbacks-table>

    <app-feedbacks-cards
      *ngIf="useCardsView()"
      [feedbacks]="filteredFeedbacks()"
      [showPendingOnly]="showPendingOnly()"
      [showTreated]="showTreated()"
      [activeFilter]="activeFilter()"
      [highlightFeedbackId]="highlightFeedbackId()"
      (openReplyModal)="openReplyModal($event)"
      (openCallModal)="openCallModal($event)"
      (toggleTreatedView)="toggleTreatedView()"
      (openBulkReply)="openBulkReplyWithSelection($event)"
      (archiveFeedback)="handleArchiveFeedback($event)">
    </app-feedbacks-cards>



    <!-- Pagination supprimée -->
  </div>

  <div class="state" *ngIf="!loading() && !error() && (!data() || data()!.feedbacks.length === 0)">{{ 'satisfaction.main.noFeedback' | translate }}</div>



  <!-- Modale de réponse individuelle -->
  <app-reply-modal
    [show]="showReplyModal"
    [feedback]="selectedFeedback"
    (close)="closeReplyModal()"
    (sendReply)="onSendReply($event)"
    (noReply)="onNoReply()">
  </app-reply-modal>

  <!-- Modale d'historique de réponse -->
  <app-reply-history-modal
    [show]="showReplyHistoryModal"
    [feedback]="selectedFeedback"
    (close)="closeReplyHistoryModal()">
  </app-reply-history-modal>

  <!-- Modale de réponse en masse -->
  <app-bulk-reply-modal
    [show]="showBulkReplyModal"
    [selectedFeedbacks]="selectedFeedbacks()"
    (close)="closeBulkReplyModal()"
    (sendBulkReply)="onSendBulkReply($event)">
  </app-bulk-reply-modal>

  <!-- Modale d'appel -->
  <app-call-modal
    [show]="showCallModal"
    [feedback]="selectedCallFeedback"
    (close)="closeCallModal()"
    (markAsCalled)="onMarkAsCalled($event)"
    (noReply)="onNoReply()">
  </app-call-modal>

  <!-- Modale d'historique d'appel -->
  <app-call-history-modal
    [show]="showCallHistoryModal"
    [feedback]="selectedCallFeedback"
    (close)="closeCallHistoryModal()"
    (updateContent)="onUpdateCallContent($event)">
  </app-call-history-modal>

  <!-- DEPRECATED (2026-09-08) : 3 modales actions correctives retirées avec la fonctionnalité --
       voir la note complète en tête de satisfaction.component.ts.
  <app-actions-list-modal
    [show]="showActionsListModal()"
    [inline]="inline"
    [refreshTrigger]="actionsData()"
    (close)="closeActionsListModal()"
    (actionUpdated)="onActionUpdated()"
    (editAction)="onEditAction($event)"
    (createAction)="openCreateActionModal()">
  </app-actions-list-modal>

  <app-edit-action-modal
    [show]="showEditActionModal()"
    [action]="selectedAction()"
    [establishmentId]="selectedActionEstablishmentId() || ''"
    (close)="closeEditActionModal()"
    (updateAction)="onUpdateAction($event)">
  </app-edit-action-modal>

  <app-create-action-modal
    [show]="showCreateActionModal()"
    [establishmentId]="getCreateActionEstablishmentId() || ''"
    [selectedFeedbackIds]="getSelectedFeedbackIds()"
    (close)="closeCreateActionModal()"
    (createAction)="onCreateAction($event)">
  </app-create-action-modal>
  -->
</div>
